
import AppAccountingBookyear from "@/components/settings-default/AccountingBookYear.vue";
import AppDefaultCentral from "@/components/settings-default/AccountingDefaultCentral.vue";
import AppAccountingDefault from "@/components/settings-default/AccountingDefault.vue";
import Vue from "vue";
import { IBreadCrumb } from "winfakt-vue-components";
import AppAccountingClosedPeriod from "@/components/settings-default/AccountingClosedPeriods.vue";
import AppCustomReportButtonList from "@/components/view-editor/CustomReportButtonList.vue";
import { AuthService } from "@/services";

export default Vue.extend({
	computed: {
		isDevMode(): boolean {
			return AuthService.isDevModeEnabled;
		},
		path(): any[] {
			return [{
				to: "/settings", value: this.$ct("general")
			},      {value: this.$ct("accounting")}] as IBreadCrumb[];
		}
	},
	components: {
		AppAccountingDefault,
		AppAccountingBookyear,
		AppDefaultCentral,
		AppAccountingClosedPeriod,
		AppCustomReportButtonList
	},
	i18nEx: {
		componentPrefix: "components.settings-default"
	}
});
